import { graphQLUtils } from 'javascripts/shared/utils/graphql_utils';
import { GraphQLClient } from 'graphql-request';

const endpoint = '/api/graphql';
// Note well: While the `credentials` value defaults to `same-origin` in modern browser versions,
// many older versions of Chrome/Firefox default this to `omit` which will cause credentials
// to be dropped and a high volume of unauthorized GraphQL errors, unless it's set.
//
// See https://github.com/github/fetch/#sending-cookies
const graphQLClient = new GraphQLClient(endpoint, { credentials: 'same-origin' });

// Returns a promise that returns data from a graphQL query.
function get(query, variables = {}) {
  return graphQLClient.request(query, variables).catch(error => {
    // Check for an Unauthorized error indicating user's session has expired on the page.
    if (graphQLUtils.isUnauthorizedError(error?.response?.errors)) {
      graphQLUtils.handleSessionExpired(error?.request?.query);
    } else {
      throw error;
    }
  });
}

export const graphQL = {
  get,
};
